import { ServiceTypeEnum, ObservationTypeEnum } from 'utils/enums';
import { CONSULT_TABS } from 'features/consults/utils/constants';
import eegFormFields from '../EEG/formFields';

const hasValue = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return value !== null && value !== undefined && value !== '';
};

const getInheritedSeizureValues = ({ consult, consultMainType }) => {
  if (
    ![ServiceTypeEnum.EEG, ServiceTypeEnum.PEDS_EEG].includes(consultMainType)
  ) {
    return null;
  }

  const inheritedSeizure = consult?.sourceConsultInheritedValues?.seizure;
  const currentEegTabData = consult?.[CONSULT_TABS.EEG] || {};

  if (
    inheritedSeizure?.sourceObservationType !== ObservationTypeEnum.HOOK_UP ||
    (inheritedSeizure?.requiredObservationType &&
      inheritedSeizure.requiredObservationType !== ObservationTypeEnum.INITIAL_READ)
  ) {
    return null;
  }

  const changes = {};
  const predefinedValues = inheritedSeizure?.values?.predefinedValues;
  const freeTextValue = inheritedSeizure?.values?.freeTextValue;

  if (
    !hasValue(currentEegTabData[eegFormFields.seizurePredefined.name]) &&
    Array.isArray(predefinedValues) &&
    predefinedValues.length > 0
  ) {
    changes[eegFormFields.seizurePredefined.name] = predefinedValues;
  }

  if (
    !hasValue(currentEegTabData[eegFormFields.seizureFreeText.name]) &&
    hasValue(freeTextValue)
  ) {
    changes[eegFormFields.seizureFreeText.name] = freeTextValue;
  }

  return Object.keys(changes).length > 0 ? changes : null;
};

export default getInheritedSeizureValues;
